// extracted by mini-css-extract-plugin
export var text = "styles-module--text--20eyX";
export var list = "styles-module--list--1-_Kr";